const TriggerComparisonTypes = {
  TRIGGER_LESS_THAN: 'trigger-less-than',
  TRIGGER_GREATER_THAN: 'trigger-greater-than',
  TRIGGER_OUT_OF_RANGE: 'trigger-out-of-range',
  TRIGGER_IN_RANGE: 'trigger-in-range',
  TRIGGER_EQUALS: 'fixed-value',
};

export default TriggerComparisonTypes;
